import {axiosPrivate} from "../axios-config/axiosPrivate";
import {imageRequestConfig, standardRequestConfig} from "../axios-config/requestConfig";
import {BACKEND} from "../config/backend";

export const PROJEKT_BASE_URL = `${BACKEND}/api/v1/projekte`

export const getProjektImagesByProjektId = ({projektId}) => {
    return axiosPrivate.get(`${PROJEKT_BASE_URL}/${projektId}/images`, {
        ...imageRequestConfig
    })
}

export const deleteProjektImages = ({projektId, imageKeys}) => {
    return axiosPrivate.delete(`${PROJEKT_BASE_URL}/${projektId}/images`, {
        ...standardRequestConfig
        , params: {keys: imageKeys.join(',')}
    })
}

export const updateProjekt = ({projektData}) => {
    return axiosPrivate.put(`${PROJEKT_BASE_URL}/${projektData.projekt.ProjektID}`, projektData, {
        ...standardRequestConfig
    })
}

export const insertProjekt = ({projektData}) => {
    return axiosPrivate.post(`${PROJEKT_BASE_URL}`, projektData, {
        ...standardRequestConfig
    })
}

export const getPagedProjekte = ({artistIdList, projStatList, nextPageOffsetId, pageSize}) => {
    return axiosPrivate.get(`${PROJEKT_BASE_URL}`, {
        ...standardRequestConfig
        , params: {
            artistIdList, projStatList, nextPageOffsetId, pageSize
        }
    })
}

export const getProjektListe = ({parameters}) => {
    return axiosPrivate.get(`${PROJEKT_BASE_URL}`, {
        ...standardRequestConfig
        , params: parameters
    })
}

export const mergeProjekte = ({mergeConfig}) => {
    return axiosPrivate.put(`${PROJEKT_BASE_URL}/merge`, mergeConfig, {
        ...standardRequestConfig
    })
}

export const deleteProjekt = ({projektId}) => {
    return axiosPrivate.delete(`${PROJEKT_BASE_URL}/${projektId}`, {
        ...standardRequestConfig
    })
}

export const updateProjektList = ({parameters}) => {
    return axiosPrivate.put(`${PROJEKT_BASE_URL}/list`, parameters,{
        ...standardRequestConfig
    })
}
